// extracted by mini-css-extract-plugin
export default {"header":"Fae4v","image":"lMy8F","button":"GBlA8"};